import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { IGetPhoneCenter, IPhoneCenterSearchForm, IPhoneCenterSearchPost } from '../phoneCenter';
import { isPhoneCenterSearchFormEmpty } from 'src/components/Common/UI/SydFilter/SydFilterTypeChecker';


const convertToDataTable = (data: IGetPhoneCenter[]): IGetPhoneCenter[] => {
  const dataTableData: IGetPhoneCenter[] = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d);
  })

  return dataTableData;
}

const mapFilterData = (data: IPhoneCenterSearchForm | undefined): IPhoneCenterSearchPost | {} => {
  if (isPhoneCenterSearchFormEmpty(data) || data == undefined) { return {} };
  return data;
}

const getAllPhoneCenters = async ( {data} : {data: IPhoneCenterSearchForm | undefined}): Promise<IGetPhoneCenter[]> => {
  const filterData = mapFilterData(data);
  const response =  await axiosDefaultApi.post(`api/PhoneCenters/SearchPhoneCenters`, filterData);
  return convertToDataTable(response as unknown as IGetPhoneCenter[]);
};

type QueryFnType = typeof getAllPhoneCenters;

type UseGetAllPhoneCentersOptions = {
  data: IPhoneCenterSearchForm | undefined;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllPhoneCenters = ({ data, config }: UseGetAllPhoneCentersOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllPhoneCenters'],
    queryFn: () => getAllPhoneCenters({data}),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των τηλεφωνικών κέντρων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};